import React from "react";
import { Typography } from "antd";
import { SUCCESS_700, SUCCESS_100 } from "../../constant/colors";
import { fontWeights, sizes } from "../../constant/styles";
import { useTranslation } from "react-i18next";

import { ReactComponent as CheckIcon } from "../../assets/svg/circle_check.svg";

const { Text } = Typography;

export const Open = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <div
      {...props}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: SUCCESS_100,
        padding: "4px 8px",
        borderRadius: 4,
        gap: 5
      }}
    >
      <CheckIcon />

      <Text
        style={{
          fontSize: sizes.xsmall,
          fontWeight: fontWeights.semibold,
          color: SUCCESS_700,
          textTransform: "uppercase",
          letterSpacing: "0.15px"
        }}
      >
        {t("patientPotentialSavings.open")}
      </Text>
    </div>
  );
};
